var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFormation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_formation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19_Specific-club---matches",
    transform: "translate(-371, -880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(351, 734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_formation",
    transform: "translate(20, 146)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "whistle",
    mask: "url(#mask-2)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 4)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7758478,0 C15.4506594,0 16,0.549340647 16,1.22415219 L16,3.15442184 C16,3.68225567 15.6642415,4.14843115 15.1633655,4.31562297 L11.9356429,5.39124818 L11.7513008,5.45267941 L11.75939,5.64681946 C11.7631961,5.73816599 11.7650951,5.81184868 11.7650951,5.88254756 C11.7650951,9.12625241 9.12625241,11.7650951 5.88254756,11.7650951 C2.63884271,11.7650951 0,9.12625241 0,5.88254756 C0,2.88363026 2.29686595,0.344044105 5.2754887,0.0367516924 C5.3774787,0.00742412749 5.41788543,0 5.45905707,0 L14.7758478,0 Z M9.31596788,0.753488462 L9.05800456,0.753488462 L5.64025104,0.754342439 C5.5523676,0.768671162 5.5313873,0.772267786 5.5121903,0.773547585 C2.84324711,0.965458043 0.754342432,3.20893514 0.754342432,5.88254756 C0.754342432,8.71028778 3.05453118,11.0107527 5.88254756,11.0107527 C8.71056394,11.0107527 11.0107527,8.71028778 11.0107527,5.88254756 C11.0107527,5.68021735 10.9953328,5.47419054 10.9655137,5.23861951 C10.9434533,5.0611283 11.0502639,4.89162766 11.2205187,4.83487609 L14.9243833,3.59997222 C15.116621,3.53651632 15.2456576,3.35726887 15.2456576,3.15442184 L15.2456576,1.22415219 C15.2456576,0.96474372 15.0352563,0.754342432 14.7758478,0.754342432 L10.3288203,0.753488462 L10.0706065,0.753488462 L10.0707097,1.01171605 L10.0711332,2.07123632 C10.0711332,2.25846508 9.93315188,2.4170418 9.74994612,2.44420286 L9.67505839,2.44899767 C9.48583692,2.44830438 9.31679074,2.2792582 9.31679074,2.07113317 L9.31612898,1.01145173 L9.31596788,0.753488462 Z M5.88254756,3.3879239 C7.25781237,3.3879239 8.37717122,4.50728275 8.37717122,5.88254756 C8.37717122,7.25781237 7.25781237,8.37717122 5.88254756,8.37717122 C4.50728275,8.37717122 3.3879239,7.25781237 3.3879239,5.88254756 C3.3879239,4.50728275 4.50728275,3.3879239 5.88254756,3.3879239 Z M5.88254756,4.14226634 C4.92268582,4.14226634 4.14226634,4.92268582 4.14226634,5.88254756 C4.14226634,6.8424093 4.92268582,7.62282878 5.88254756,7.62282878 C6.8424093,7.62282878 7.62282878,6.8424093 7.62282878,5.88254756 C7.62282878,4.92268582 6.8424093,4.14226634 5.88254756,4.14226634 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFormation);
export default __webpack_public_path__ + "static/media/ic_formation.671bed3bad65ae628a4ece367d283e6d.svg";
export { ForwardRef as ReactComponent };